var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292785 7.071L5.94978 12.728L7.36378 11.314L2.41378 6.364L7.36378 1.414L5.94978 0L0.292785 5.657C0.105314 5.84453 -1.43051e-06 6.09884 -1.43051e-06 6.364C-1.43051e-06 6.62916 0.105314 6.88347 0.292785 7.071Z",
    fill: "#C6C7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeftButton);
export default __webpack_public_path__ + "static/media/scroll-left-button.cae9e7d2093b6e3bff017d5fa8f012ce.svg";
export { ForwardRef as ReactComponent };